<template lang="pug">
v-main
  v-container
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title Edit Account
      v-divider
      v-card-text
        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(color="black")
              span(style="color: #D42A2A;") *
              | &nbsp;Alias Name&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-text-field(
              v-model="bu.alias",
              label="Alias",
              :rules="[rules.required]",
              @keypress="isLetter($event)"
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(style="height: 16px;") 
              span(style="color: #D42A2A;") *
              | &nbsp;Business Unit Email&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
            small(style="color: #F08703;" class="ml-4") *Email for notification memo
          v-col(cols="5")
            v-text-field(
              v-model="bu.email",
              label="Email (Don't use personal e-mail)",
              type="email",
              :rules="[rules.required, rules.email]"
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(style="height: 16px;") 
              | &nbsp;Business Unit Phone Number&nbsp;
              span(style="font-size:.7rem; color: #909090") (Optional)
            small(style="color: #F08703;" class="ml-4") *Phone number for notification memo
          v-col(cols="5")
            vue-tel-input(
              @validate="telValidate" 
              v-model="bu.msisdn"
              style="border-top: none; box-shadow: none; border-right: none; border-left: none; border-bottom: 2px solid;"
            )
            p(style="color: #ff5252; margin: 0; font-size: 12px;" v-if="bu.msisdn.length > 0 && !validNumber") invalid Phone Number Format


        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Position&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-text-field(
              v-model="bu.position",
              label="Position",
              :rules="[rules.required]"
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Business Unit&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-text-field(
              v-model="bu.bisnis_unit",
              label="Business Unit",
              disabled
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Status&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-radio-group(v-model="bu.is_active", row)
              v-radio(label="Active", value="active")
              v-radio(label="Non Active", value="nonactive")

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Group&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-radio-group(v-model="bu.is_admin", row)
              v-radio(label="Admin", value="yes")
              v-radio(label="User", value="no")

        v-card-actions.my-8
          v-btn.custom__padding-btn(@click="$router.push(`/users/detail/${$route.params.id}`)") Back
          v-btn.custom__padding-btn(
            color="blue-secondary",
            :disabled="!formIsValid",
            @click="update()"
          ) Update

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  data: () => ({
    validNumber:  false,
    bu: {
      alias: "",
      email: "",
      msisdn: "",
      position: "",
      bisnis_unit: "",
      is_active: "",
      is_admin: "",
    },
    bisnis_units: [],
    rules: {
      required: (value) => !!value || "This field is required.",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid email format";
      },
      msisdn: (value) =>
        (value && value.length >= 10) || "Mobile number cannot be less than 10",
    },
    overlay: false,
  }),
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    formIsValid() {
      return (
        this.bu.alias &&
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.bu.email) &&
        this.bu.position &&
        (this.validNumber || this.bu.msisdn.length == 0) &&
        this.bu.bisnis_unit &&
        this.bu.is_active
      );
    },
  },
  mounted() {
    this.getData();
    // this.getBisnisUnit()
  },
  methods: {
    telValidate(telnumber) {  
      if (telnumber.valid || this.bu.msisdn.length == 0) this.validNumber = true  
      else  this.validNumber = false
    },

    getData() {
      this.overlay = true;
      let token = localStorage.getItem("token");
      axios
        .get(
          process.env.VUE_APP_API + `/users/admin/${this.$route.params.bu_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.overlay = false;
          this.bu.alias = res.data.data.alias;
          this.bu.email = res.data.data.email;
          this.bu.msisdn = res.data.data.msisdn ? `+${res.data.data.msisdn}` : "";
          this.bu.position = res.data.data.position;
          this.bu.bisnis_unit = res.data.data.business_unit.bu_name;
          this.bu.is_admin = res.data.data.is_admin ? "yes" : "no";
          this.bu.is_active = res.data.data.is_active ? "active" : "nonactive";
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err, { icon: "error" });
        })
        .finally(() => {
          this.overlay = false;
          this.loading = false;
        });
    },
    update() {
      this.overlay = true;
      // this.bu.is_active = this.bu.is_active == "active" ? true : false;
      // this.bu.is_admin = this.bu.is_admin == "yes" ? true : false;

      this.$store
        .dispatch("updateDataBuToUsers", {
          bu: this.bu,
          bu_id: `${this.$route.params.bu_id}`,
          user_id: `${this.$route.params.id}`,
        })
        .then((res) => {
          this.overlay = false;
          if (this.showDrawer) this.$store.commit("toggleDrawer");
          if (res.data.status == 200) {
            this.$toasted.success(
              "Success, the account was successfully updated",
              { icon: "check_circle" }
            );
            this.$router.push({
              name: "Users Detail",
              params: { id: `${this.$route.params.id}` },
            });
          } else {
            this.$toasted.error("Failed to Update Data", { icon: "error" });
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err.response.data.error, { icon: "error" });
        });
    },
    onBack() {
      this.$router.push({
        name: "Users Detail",
        params: { id: `${this.$route.params.id}` },
      });
    },
    isNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9 ]+$/.test(char)) return true;
      else e.preventDefault();
    },
    // getBisnisUnit(){

    //     let token = localStorage.getItem('token');
    //     axios.get(`${this.$store.state.API_URL}/business-unit/list`,
    //     {
    //         headers: { Authorization: `Bearer ${token}` }
    //     })
    //     .then(res => {
    //         this.bisnis_units = res.data.data
    //     })
    //     .catch(err => {
    //         reject(err);
    //     })
    //     .finally(() => (this.loading = false));

    // },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

.v-toolbar__content {
  box-shadow: none;
}
</style>